import { all, call, cancel, put, takeEvery } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import { deserialize } from "services/api/billing/billing-serializer";
import * as BillingSerializer from "services/api/billing/billing-serializer";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { BillingActionNames, BillingActions } from "./actions";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchBillingInfo() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.billingApi.fetch);
  if (response.result) {
    yield put(BillingActions.fetchBillingInfoSuccess(deserialize(response.result)));
  } else {
    yield put(BillingActions.fetchBillingInfoFailure({ error: response.error }));
    yield cancel();
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateBillingInfo(action: IActionWithPayload<string, { invoiceEmail: string }>) {
  const { invoiceEmail } = action.payload;

  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.billingApi.updateBillingAddress, invoiceEmail);
  if (response.responseStatus === 200) {
    yield put(BillingActions.updateBillingInfoSuccess(BillingSerializer.deserialize(response.result)));
  } else {
    yield put(BillingActions.updateBillingInfoFailure({ error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateBillingInfoSuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.UPDATE_BILLING_ADDRESS_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateBillingInfoFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.UPDATE_BILLING_ADDRESS_FAILED),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* billingSaga() {
  yield all([
    takeEvery(BillingActionNames.FETCH_BILLING_INFO_REQUEST, fetchBillingInfo),
    takeEvery(BillingActionNames.UPDATE_BILLING_INFO, updateBillingInfo),
    takeEvery(BillingActionNames.UPDATE_BILLING_INFO_FAILURE, updateBillingInfoFailure),
    takeEvery(BillingActionNames.UPDATE_BILLING_INFO_SUCCESS, updateBillingInfoSuccess),
  ]);
}
